import { useEffect, useRef, useState } from 'react'

const MIN_VIEWERS = 19
const MAX_VIEWERS = 84

function randomBetween(min: number, max: number): number {
  return min + Math.random() * (max - min)
}

/**
 * Simulates a live "people viewing this page" counter with a gentle random
 * walk, so the number keeps moving without ever looking erratic.
 */
export function useLiveViewers(initial = 42): number {
  const [viewers, setViewers] = useState(() =>
    Math.round(randomBetween(initial - 6, initial + 9))
  )
  const timer = useRef<number | null>(null)

  useEffect(() => {
    function tick() {
      setViewers(current => {
        const drift = Math.round(randomBetween(1, 3)) * (Math.random() < 0.5 ? -1 : 1)
        const next = current + drift
        if (next < MIN_VIEWERS) return current + Math.abs(drift)
        if (next > MAX_VIEWERS) return current - Math.abs(drift)
        return next
      })
      timer.current = window.setTimeout(tick, randomBetween(2600, 5200))
    }

    timer.current = window.setTimeout(tick, randomBetween(2600, 5200))
    return () => {
      if (timer.current) window.clearTimeout(timer.current)
    }
  }, [])

  return viewers
}
